import { CONTEXT_MENU_GROUP_NAME } from 'src/js/modules/blocks/constants/common';

const filteredMatchedGroups = (groups) =>
  groups.filter((group) => group.name !== CONTEXT_MENU_GROUP_NAME);

export default filteredMatchedGroups;
